import { createSelector } from '@reduxjs/toolkit';

import PAGES from '@/constants/pages';

import modelsEnableSelector from './modelsEnable';

/**
 * Получить флаги доступности страниц
 */
const availablePagesMapSelector = createSelector(modelsEnableSelector, modelsEnable => {
  const availablePagesMap: Record<keyof typeof PAGES, boolean> = {
    Cars: true,
    CarId: true,
    Models: modelsEnable,
    Comparison: true,
    Favorites: true,
    404: true,
    500: true,
  };

  return availablePagesMap;
});

export default availablePagesMapSelector;
